declare global {
  interface Window {
    Shopify?: {
      analytics?: {
        publish: (eventName: string, data?: Record<string, unknown>) => void;
      };
      routes?: {
        root: string;
      };
      loadFeatures?: (...args: unknown[]) => void;
      locale: string;
    };
  }
}

export const publishShopifyAnalytics = (eventName: string, data: Record<string, unknown> = {}): void => {
  try {
    window.Shopify?.analytics?.publish?.(eventName, data);
  } catch (error) {
    console.error('Saywhatt: Shopify analytics publish failed', error);
  }
};
